import { Injectable, OnDestroy } from '@angular/core';
import { GlobalFilter, InsightFilter, KPIDashboardScreen, SupplyMode, TimeFrameMode, InsightMode } from '../interfaces/global-filter-model';
import { BehaviorSubject, ReplaySubject, Subject } from 'rxjs';
import { Scenario } from 'src/app/core/models/scenario';

@Injectable()
export class MondelezDataService implements OnDestroy {
  private _scenarioMaster = new ReplaySubject<Scenario[]>(1);
  public scenarioMaster = this._scenarioMaster.asObservable();

  private _assignmentData = new Subject<any>();
  public assignmentData = this._assignmentData.asObservable();

  private _timeFrameMode = new BehaviorSubject<TimeFrameMode>(TimeFrameMode.YEARLY);
  public timeFrameMode = this._timeFrameMode.asObservable();

  private _currentScenario = undefined;
  private _currentScenarioChanged = new ReplaySubject<any>(1);
  public currentScenarioChanged = this._currentScenarioChanged.asObservable();

  private _supplyMode = new BehaviorSubject<string>(SupplyMode.MANUFACTURING);
  public supplyMode = this._supplyMode.asObservable();

  private _insightMode = new BehaviorSubject<string>(InsightMode.COMMERCIAL_INSIGHTS);
  public insightMode = this._insightMode.asObservable();

  private SimulationtimeFrame = new BehaviorSubject<TimeFrameMode>(TimeFrameMode.YEARLY);
  public SimulationtimeFrameValue = this.SimulationtimeFrame.asObservable();

  private _kpiScreen = new BehaviorSubject<KPIDashboardScreen>(KPIDashboardScreen.FINANCIAL);
  public kpiScreen = this._kpiScreen.asObservable();

  private _spaceThroughputMode = new BehaviorSubject<string>('space');
  public spaceThroughputModeValue = this._spaceThroughputMode.asObservable();

  private _totalAmbiRefMode = new BehaviorSubject<string>('total');
  public totalAmbiRefModeValue = this._totalAmbiRefMode.asObservable();

  private kpiTimeFrame = new BehaviorSubject<TimeFrameMode>(TimeFrameMode.QUARTERLY);
  kpiTimeFrameValue = this.kpiTimeFrame.asObservable();

  public solvedSimulation = new Subject<boolean>();

  public _comExcelDownload = new BehaviorSubject<any>(null);
  public comExcelDownload = this._comExcelDownload.asObservable();

  constructor() {}

  ngOnDestroy(): void {}

  public updateTimeFrameMode(mode) {
    this._timeFrameMode.next(mode);
  }

  public updateSimulatedTimeFrameMode(mode) {
    this.SimulationtimeFrame.next(mode);
  }

  public updateSpaceThroughputMode(mode) {
    this._spaceThroughputMode.next(mode);
  }

  public updateTotalAmbiRefMode(mode) {
    this._totalAmbiRefMode.next(mode);
  }

  public updateSupplyMode(mode) {
    this._supplyMode.next(mode);
  }

  public updateInsightMode(mode) {
    this._insightMode.next(mode);
  }

  public updateScenarioList(scenarios: Scenario[]) {
    this._scenarioMaster.next(scenarios.slice());
  }

  public updateAssignmentData(data: any) {
    this._assignmentData.next(data);
  }

  public updateCurrentScenario(scenario: Scenario) {
    this._currentScenario = scenario;
    this._currentScenarioChanged.next(scenario);
  }

  public updateKpiTimeFrameMode(mode) {
    this.kpiTimeFrame.next(mode);
  }

  public updateKpiScreen(mode) {
    this._kpiScreen.next(mode);
  }

  public updateCommercialExcelDownload(data) {
    this._comExcelDownload.next(data);
  }

  public get currentScenario() {
    return this._currentScenario;
  }
}
